import React, { useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import { useTranslation } from "react-i18next";
import { Button, Stack, Spinner, Form } from "react-bootstrap";
import { phoneRegex, emailRegex } from "../../../utilities/validators";
import AutoClaimReportForm from "../../ClaimReport/AutoClaimReportForm";
import { postClaimReport } from "../../../apis";

const MasterForm = ({ id, claimreportName, fullname }) => {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [telephone, setTelephone] = useState("");
  const [message, setMessage] = useState("");
  // const [currentStep, setCurrentStep] = useState(1);
  const [loading, SetLoading] = useState(false);

  const { t } = useTranslation();

  const submit = () => {
    let submitObject = {
      name,
      email,
      telephone,
      insurrance: fullname,
      message,
    };
    SetLoading(true);
    // we check if name, email or telephone fields are valid
    if (!name || !email || !telephone) {
      toast.error(
        "Assurer d'entrer votre nom, numero de telephone et e-mail !"
      );
      SetLoading(false);
      return;
    }
    // Validate Phone number from stackoverflow
    else if (phoneRegex(submitObject.telephone)) {
      toast.error("Numero de telephone incorrect");
      SetLoading(false);
      return;
    } else if (emailRegex(submitObject.email)) {
      toast.error("E-mail incorrect");
      SetLoading(false);
      return;
    }

    postClaimReport(submitObject).then((res) => {
      setName("");
      setEmail("");
      setTelephone("");
      setMessage("");
    });
    SetLoading(false);
  };

  return (
    <div className="invoice-page__modal">
      <h2>{t("claim-report_page_masterform_caption")}{fullname}</h2>
      <Form className="invoice-page__modal_form">
        <AutoClaimReportForm
          name={name}
          setName={setName}
          telephone={telephone}
          setTelephone={setTelephone}
          email={email}
          setEmail={setEmail}
        />
      </Form>
      <Stack
        direction="horizontal"
        gap={2}
        className="invoice-page__modal_step-buttons"
      >
        <Button variant="green" className="ms-auto" onClick={submit}>
          {loading ? (
            <Spinner
              variant="standard"
              as="span"
              size="sm"
              role="status"
              animation="border"
              aria-hidden="true"
            />
          ) : (
            t("contact_page_form_submit_button")
          )}
        </Button>
      </Stack>
      <ToastContainer containerId="an id" draggable={false} />
    </div>
  );
};

export default MasterForm;
